import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import GlobalContext from 'agency/digital_renderer/utils/context'
import deviceStyle from 'agency/digital_renderer/utils/deviceStyle'
import { getShortCodeValue } from 'functions/replaceTextShortCodes'

// eslint-disable-next-line import/no-cycle
import ElementContainer from '../../ElementContainer'

const findContainer = items => items.find(item => item.item_type === 'container')

const filterData = (data, filters) => {
  const { limit, offset } = filters || {}

  const filterOffset = offset && offset !== 0 ? offset : 0
  const filterLimit = limit ? limit + filterOffset : null

  const limited = filterLimit
    ? data.slice(filterOffset, filterLimit)
    : data.slice(filterOffset)

  return limited
}

const renderItems = (container, array) => array.map((item, index) => (
  // eslint-disable-next-line react/no-array-index-key
  <div key={index} style={deviceStyle(container)}>
    <ElementContainer
      forwardContextToItems={item}
      section={container}
      renderNested
      render={({ itemComponents }) => itemComponents.map(component => component)}
    />
  </div>
))

const DataLoop = (props) => {
  const {
    context: componentContext,
    data: { value: rawValue },
    items,
    options,
  } = props

  const { limit, offset } = options || {}

  // Context
  const defaultContext = useContext(GlobalContext)
  const contextData = { ...defaultContext, ...componentContext }

  const array = getShortCodeValue(rawValue, contextData, { returnRawValue: true })

  // Check if the array is actually an array (or object is js)
  if (!array || !Array.isArray(array)) return null

  const filteredArray = filterData(array, { limit, offset })

  const container = findContainer(items) || {}

  return renderItems(container, filteredArray)
}

DataLoop.propTypes = {
  context: PropTypes.object,
  data: PropTypes.object,
  items: PropTypes.array,
}

DataLoop.defaultProps = {
  data: {},
  options: {},
}

export default DataLoop
